import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {DataService} from 'src/app/services/data.service';
import {TrustiiService} from 'src/app/services/trustii.service';

@Component({
  selector: 'app-test-model',
  templateUrl: './test-model.component.html',
  styleUrls: ['./test-model.component.scss']
})
export class TestModelComponent implements OnInit {
  datasetId = 0;
  dataset: any;
  features = [];
  fetchingPrediction = false;
  predictedValues = null;
  datasetConfigurationFetch = false;
  mode = 'class';

  constructor(
    private router: Router,
    private dataservice: DataService,
    private trustiiService: TrustiiService) {
  }

  /**
   * Init component
   *
   * @return void
   */
  ngOnInit() {
    if (!this.dataservice.data.trainigData || !this.dataservice.data.modelId) {
      this.router.navigateByUrl('', {skipLocationChange: false});
    }
    this.getDataSet();
  }

  getDataSet() {
    this.trustiiService.getDataset(this.dataservice.data.trainigData).subscribe(
      (res) => {
        if ('in-progress' === res.data.status) {
          setTimeout(() => {
            this.getDataSet();
          }, 3 * 1000); // poll every 3 seconds
        } else {
          this.features = res.data.fields.filter(element => element.isTarget !== 1).map(item => {
            return {name: item.name, value: Math.floor(Math.random() * 100) / 100, fieldOrder: item.fieldOrder};
          }).sort((a, b) => a.fieldOrder - b.fieldOrder);
          this.dataset = res.data;
          console.log(this.dataset);
          this.datasetConfigurationFetch = true;
        }
      },
      (err) => {
      }
    );
  }

  preapareInputDataset() {
    const data = [];
    const cols = [];
    this.features.forEach(item => {
      data.push(item.value);
      cols.push(item.name);
    });
    return [[data], cols];
  }

  predictOutput(e) {
    e.preventDefault();
    this.fetchingPrediction = true;
    this.fetchPrediction(this.preapareInputDataset());
  }

  fetchPrediction(inputDataset) {
    this.predictedValues = null;
    this.trustiiService.runMLModel(this.dataservice.data.trainigData, this.dataservice.data.modelId, this.mode, inputDataset).subscribe(
      (res) => {
        if ('in-progress' === res.data.status) {
          setTimeout(() => {
            this.getInsightDetails(res.data.id);
          }, 3 * 1000); // poll every 3 seconds
        }
      },
      (err) => {
        this.fetchingPrediction = false;
      }
    );
  }

  getInsightDetails(insightId) {

    this.trustiiService.getInsightDetails(insightId).subscribe(
      (res) => {
        if ('in-progress' === res.data.status) {
          setTimeout(() => {
            this.getInsightDetails(insightId);
          }, 3 * 1000); // poll every 3 seconds
        } else if ('error' === res.data.status) {
          this.fetchingPrediction = false;

        } else {
          this.trustiiService.getInsightData(insightId, true).subscribe(
            (res1) => {
              this.predictedValues = res1.data.toString();
              this.fetchingPrediction = false;
            },
            (err1) => {
              this.fetchingPrediction = false;
            });
        }
      }, (err) => {
        this.fetchingPrediction = false;
      });
  }
}
